<footer class="py-lg-2 pt-3">
    <section class="container footer">
        <article class="row">
            <div class="col-lg-5 mt-lg-0 mt-3 footer__copyright">
                ©2020 <span class="primary-text">Fitscovery</span>. All Rights Reserved
            </div>
            <div class="col-lg-7 footer__links">
                <span *ngFor="let page of pages">
                    <a href="{{ page.baseUrl }}">{{page.title|translate}}</a>
                </span>
            </div>
        </article>
    </section>
</footer>